/* eslint-disable react/jsx-no-bind */
import { useMemo } from "react";
import { useFilterStore } from "~/components/build/Show/lib/useFilterStore";
import { FilterByOption } from "~/components/build/Show/lib/filterConstants";
import { useTrack } from "~/components/build/Show/lib/useTrack";
import { FilterChips, type SelectedFilter } from "~/components/build/Show/components/Filter";
import {
  STATE_FILTER_CATEGORY_KEY,
  useFilterCategories,
} from "~/components/build/Show/components/FilterByMenu";

/**
 * Chip strip companion to `FilterByDropdown`. Reads the same
 * `useFilterStore` state and the same `useFilterCategories()` hook so the
 * toolbar dropdown and the per-chip submenus stay in sync — chips show the
 * same state icons, counts, and "N others with no results" affordance as the
 * main dropdown without prop-drilling.
 */
export default function FilterByChips() {
  const filterBy = useFilterStore((state) => state.filterBy);
  const setFilterBy = useFilterStore((state) => state.setFilterBy);
  const track = useTrack();
  const categories = useFilterCategories();

  const selected = useMemo<SelectedFilter[]>(
    () => filterBy.map((value) => ({ categoryKey: STATE_FILTER_CATEGORY_KEY, value })),
    [filterBy],
  );

  function handleChange(next: SelectedFilter[]) {
    const newFilterBy = next
      .filter((filter) => filter.categoryKey === STATE_FILTER_CATEGORY_KEY)
      .map((filter) => filter.value as FilterByOption);
    setFilterBy(newFilterBy);
    track("Change State Filter", { enabled: newFilterBy });
  }

  return (
    <FilterChips
      testId="filter-by-chip"
      categories={categories}
      selected={selected}
      onChange={handleChange}
    />
  );
}
